export default "__VITE_ASSET__060c263f__"